import { connect } from 'react-redux'
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'

import { closeModalNotCovidCoverage } from '../../../actions/purchaseActions'

export class ModalNotCovidCoverage extends Component {
    constructor(props) {
        super(props)

        this.goToSearchPage = this.goToSearchPage.bind(this);
    }

    goToSearchPage() {
        this.props.closeModalNotCovidCoverage();
        this.props.history.go(-1)
    }

    render() {
        if (!this.props.isModalNotCovidCoverage)
            return <div />

        const benefits = this.props.rawProductCoverage;

        let franchise = benefits.filter(
            benefit => benefit.code === '500'
        )
        franchise = franchise.length && franchise[0]
        const franchiseCoverage = franchise.coverage.toUpperCase() === 'NAO' || franchise.coverage.toUpperCase() === 'NÃO';

        return (
            <div className="comp_modalpagamento quotationDateWarning-modal franchise-modal" onClick={this.props.closeModalNotCovidCoverage}>
                <div className="modalcontents" onClick={e => e.stopPropagation()}>
                    <div onClick={this.props.closeModalNotCovidCoverage} className="close-btn"> &times; </div>
                    <div className="contents">
                        <div className="modalmiddle">
                            <h3>Atenção as exigências dos países</h3>

                            <p className="text-middle">Esse seguro é uma excelente opção, mas atenção ao viajar para o Chile e/ou Argentina, pois esses países exigem coberturas específicas para COVID-19</p>
                            {!franchiseCoverage && <p className="text-middle">O seguro viagem escolhido é uma excelente opção, mas atenção, para acionar Despesas Médicas Hospitalares (DMH) existe uma franquia de {franchise.coverage}. Os demais benefícios estão isentos de franquia.</p>}
                        </div>
                        <div className="choosecontainer">
                            <div className="optionone">
                                <button className="button" onClick={this.goToSearchPage}>
                                    <span>Voltar à pesquisa</span>
                                </button>
                            </div>
                        </div>
                        <div className="choosecontainer continue">
                            <div className="optionone">
                                <button className="button" onClick={this.props.closeModalNotCovidCoverage}>
                                    <span>Continuar</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}

export default connect(
    state => ({
        isModalNotCovidCoverage: state.purchase.isModalNotCovidCoverage,
        rawProductCoverage: state.coverage.rawProductCoverage,
    }),
    {
        closeModalNotCovidCoverage
    }
)(withRouter(ModalNotCovidCoverage));



// WEBPACK FOOTER //
// ./src/components/purchase/modal_not_covid_coverage/index.jsx